import { usuarios } from 'cifra-api-js';

/**
 * Decorator para el json de usuario
 */
export default class Usuario {
  constructor(data, _options = {}) {
    Object.assign(this, data);
  }

  get nombreCompleto() {
    return usuarios.fullname(this);
  }

  get displayGrupoPrincipal() {
    return this.grupo_academico_principal?.etiqueta;
  }
}
